import { CommonPlaylistRegistration } from './common-playlist-registratrion';

export class CustomTagElementAnnouncement {
  id: number;
  name: string;
  isExpand: boolean;
  isChecking: boolean;
  commonPlaylistRegistration: Array<CommonPlaylistRegistration>;
}
